var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CommunicationsManager = /** @class */ (function () {
    /**
     * Constructor.
     */
    function CommunicationsManager() {
        this.initialized = false;
        this.disposed = false;
    }
    /**
     * Initialize the manager.
     */
    CommunicationsManager.prototype.initializeCore = function () { };
    /**
     * Clean any resources before the manager is disposed.
     */
    CommunicationsManager.prototype.disposeCore = function () { };
    /**
     * Initialize the manager.
     */
    CommunicationsManager.prototype.initialize = function () {
        if (this.initialized)
            return;
        this.initialized = true;
        this.initializeCore();
    };
    /**
     * Dispose of the manager.
     */
    CommunicationsManager.prototype.dispose = function () {
        if (this.disposed)
            return;
        this.disposed = true;
        this.disposeCore();
    };
    return CommunicationsManager;
}());
export { CommunicationsManager };
/**
 * Communications manager base class.
 */
var CommunicationsManagerOf = /** @class */ (function (_super) {
    __extends(CommunicationsManagerOf, _super);
    /**
     * Constructor
     *
     * @param inboundEndpoint The endpoint for receiving messages.
     * @param inboundEventType The types of messages to receive.
     * @param outboundEndpoint The endpoint to sent messages.
     * @param outboundEventType The messages to send.
     */
    function CommunicationsManagerOf(inboundEndpoint, inboundEventType, outboundEndpoint, outboundEventType) {
        var _this = _super.call(this) || this;
        _this.inboundEndpoint = inboundEndpoint;
        _this.inboundEventType = inboundEventType;
        _this.outboundEndpoint = outboundEndpoint;
        _this.outboundEventType = outboundEventType;
        _this.onEventReceived = null;
        _this.eventHandler = function (e) { _this.handleEvent(e); };
        return _this;
    }
    /**
     * Handle the received events.
     *
     * @param e The received event.
     */
    CommunicationsManagerOf.prototype.handleEvent = function (e) {
        if (!this.onEventReceived)
            return;
        var evt = this.readEvent(e);
        if (evt) {
            this.onEventReceived(evt);
        }
    };
    /**
     * @inheritdoc
     */
    CommunicationsManagerOf.prototype.initializeCore = function () {
        if (this.inboundEndpoint && this.eventHandler) {
            this.startReceiving(this.inboundEndpoint, this.eventHandler);
        }
        _super.prototype.initializeCore.call(this);
    };
    /**
     * @inheritdoc
     */
    CommunicationsManagerOf.prototype.disposeCore = function () {
        if (this.inboundEndpoint && this.eventHandler) {
            this.stopReceiving(this.inboundEndpoint, this.eventHandler);
        }
        this.eventHandler = null;
        this.onEventReceived = null;
        this.inboundEndpoint = null;
        _super.prototype.disposeCore.call(this);
    };
    /**
     * @inheritdoc
     */
    CommunicationsManagerOf.prototype.send = function (event) {
        if (this.outboundEndpoint) {
            this.sendEvent(this.outboundEndpoint, event);
        }
    };
    /**
     * @inheritdoc
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CommunicationsManagerOf.prototype.setEventReceivedCallback = function (callback) {
        this.onEventReceived = callback;
    };
    return CommunicationsManagerOf;
}(CommunicationsManager));
export { CommunicationsManagerOf };
//# sourceMappingURL=manager.js.map